/**
 * @generated SignedSource<<959893f96e9ad8869410e960b6096a28>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type plainText_nativeIssueTable_PlainTextCellOld_fieldRef$data = {
  readonly hoverOrFocusState?: {
    readonly " $fragmentSpreads": FragmentRefs<"popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent">;
  } | null | undefined;
  readonly text: string | null | undefined;
  readonly " $fragmentType": "plainText_nativeIssueTable_PlainTextCellOld_fieldRef";
};
export type plainText_nativeIssueTable_PlainTextCellOld_fieldRef$key = {
  readonly " $data"?: plainText_nativeIssueTable_PlainTextCellOld_fieldRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"plainText_nativeIssueTable_PlainTextCellOld_fieldRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "plainText_nativeIssueTable_PlainTextCellOld_fieldRef",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "text"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "concreteType": "JiraFieldHoverOrFocusState",
              "kind": "LinkedField",
              "name": "hoverOrFocusState",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraSingleLineTextField"
};

(node as any).hash = "8c808a384a02316ed71e3d9fb3daf759";

export default node;
